import React from 'react';

interface CpsPageProps {
  children: React.ReactNode;
  className?: string;
}

const CpsPage: React.FC<CpsPageProps> = props => {
  return <div className={`cpsPage ${props.className || ''}`}>{props.children}</div>;
};

export default CpsPage;
